type FormMap = { [key: string]: any }

export function createFormData(data: FormMap): FormData {
    const fd = new FormData()
    for (const key in data)
        if (data[key] != undefined) fd.append(key, data[key])
    return fd
}
